import styled from 'styled-components'

import { Separator } from '@root/shared/ui-kit'

import type { ChildrenProps } from '@root/shared/react'

type FormSectionProps = { header?: string } & ChildrenProps

export const FormSection = (props: FormSectionProps) => (
  <Root>
    {props.header ? <Header text={props.header} /> : undefined}
    <Body>{props.children}</Body>
  </Root>
)
const Root = styled.section`
  display: grid;
  gap: 12px;
`
const Body = styled.div`
  display: grid;
  gap: 7px;
`
type SectionHeaderProps = {
  text?: string
}
const Header = (props: SectionHeaderProps) => (
  <HeaderRoot>
    <span>{props.text}</span>
    <Separator />
  </HeaderRoot>
)

const HeaderRoot = styled.div`
  text-align: center;
  display: grid;
  color: var(--text-10);
  line-height: 12px;
  font-size: 10px;
  gap: 7px;
`
